import { useState } from 'react';
import { openNewWindow } from '@/utils/helpers';
import { OpenNewWindowParams } from '@/utils/helpers.types';

export const useNewWindow = () => {
  const [newWindow, setNewWindow] = useState<Window | null>(null);

  const open = (params?: OpenNewWindowParams) => {
    setNewWindow(openNewWindow(params));
  };

  const close = () => {
    if (!newWindow) return;
    newWindow.close();
    setNewWindow(null);
  };

  return {
    open,
    close,
    newWindow,
  };
};
